export const SOFTLINE_API_MDE_BESTELLERFASSUNG_BEWEGUNGEN = '/v1/bestellung/bewegung/entities'
export const SOFTLINE_API_MDE_BESTELLERFASSUNG_ABSCHLUSS = '/v1/bestellung/abschluss'
export const SOFTLINE_API_MDE_BESTELLERFASSUNG_ARTIKEL = '/v1/bestellung/artikel/entities'
export const SOFTLINE_API_MDE_BESTELLERFASSUNG_CHECK_EINGABE = '/v1/bestellung/artikel/entities/checkEingabe'
export const SOFTLINE_API_MDE_BESTELLERFASSUNG_KOPF = '/v1/bestellung'
export const SOFTLINE_API_BESTELLVORSCHLAG_SCAN = '/v1/bestellvorschlag/scan/{{code}}';
export const SOFTLINE_API_MDE_BESTELLERFASSUNG_ARTIKEL_DETAIL = 'detail'
